angular.module('tgaAdmin').controller('AddPlayerController', [
  '$scope',
  '$state',
  'playersService',
  'userService',
  'flashService',
  '$translate',
  function ($scope, $state, playersService, userService, flashService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      playerId: $state.params.id || null,
    };

    $scope.viewmodel = {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      initials: null,
      display_name: null,
    };

    $scope.initialize = function () {
      if ($scope.data.playerId) {
        userService.getUser($scope.data.playerId).then((user) => {
          $scope.viewmodel = user;

          // @TODO: use resolve to handle this
          $scope.title = `<span class="text-muted">Edit Player /</span> ${user.first_name} ${user.last_name}`;
        });
      }
    };

    $scope.actions = {
      submit(form) {
        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;

        playersService.registerPlayer($scope.viewmodel).then(
          (user) => {
            if (user.exists) {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${user.message}`,
                'danger',
              );
              form.processing = false;
            } else {
              flashService.set('<span class="fa fa-check"></span> Player added.', 'success');
              form.processing = false;
              $state.go('v1.players');
            }
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
